module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-4-91005e556b25b0fa68253afaa9a0825e.svg";